// extracted by mini-css-extract-plugin
module.exports = {"description":"PromptDialog_description__13JP8","descriptionLine":"PromptDialog_descriptionLine__3mFHh","field":"PromptDialog_field__6WEIE","input":"PromptDialog_input__11yAf"};